import { Injectable } from '@angular/core';
import { ApiService } from '@core/api.service';
import { CrudService } from 'collection';
import { Collection, CollectionModel, GetEntityModel, Item, ItemModel } from 'collection';

import { BehaviorSubject, Observable } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';

@Injectable({ providedIn: 'root' })
export class ClientsService {
  getAvailableNumberRequest: GetEntityModel;
  collection: CollectionModel;
  item: ItemModel;
  isOpenSidebar: boolean = true;

  private _isOpenSidebar: BehaviorSubject<boolean> = new BehaviorSubject(this.isOpenSidebar);

  get $isOpenSidebar(): Observable<boolean> {
    return this._isOpenSidebar.asObservable();
  }

  toggleSidebar(): void {
    this.isOpenSidebar = !this.isOpenSidebar;
    this._isOpenSidebar.next(this.isOpenSidebar);
  }

  constructor(
    private _breadcrumbService: BreadcrumbService,
    private _api: ApiService,
    private _crud: CrudService
  ) {
    this.collection = new Collection({
      api: this._api.clients,
      params: {
        expand: 'full_name,avatars'
      }
    });

    this.collection.hardReloadAfter.updating = true;
    this.collection.hardReloadAfter.deleting = true;
    this.collection.loadByScrolling = false;

    this.item = new Item({
      api: this._api.clients,
      params: {
        expand: 'billing_address,shipping_address'
      }
    });

    this.getAvailableNumberRequest = this._crud.createGetEntity({ name: 'client/available-number' });
  }
}
